module.exports = __webpack_public_path__ + "static/media/text-thumb.0f456809.png";